import React from 'react';
import PropTypes from 'prop-types';

import { BREEDER_CENTER_PATH } from 'dpl/shared/constants/urls';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

import IntroBanner from './IntroBanner';
import EvergreenContent from './EvergreenContent';
import NewsItem from './NewsItem';

export default function Layout({
  newsItems,
  evergreenContent,
  isLoading,
  isFirstTime
}) {
  return (
    <div className="BreederNewsLayout">
      <LoadingWrapper isLoading={ isLoading } className="transform-center-all">
        {
          isFirstTime &&
            <IntroBanner />
        }
        <div className="pv6 ph6">
          <div className="flex items-center mb6">
            <p className="fw-medium flex-auto">News and Resources</p>
            <a href={ BREEDER_CENTER_PATH } className="f2 link--primary fw-medium">See all</a>
          </div>
          {
            newsItems.map(item => (
              <div key={ item.id } className="mb6">
                <NewsItem item={ item } />
              </div>
            ))
          }
          {
            evergreenContent &&
              <EvergreenContent content={ evergreenContent } />
          }
        </div>
      </LoadingWrapper>
    </div>
  );
}

Layout.propTypes = {
  newsItems: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFirstTime: PropTypes.bool,
  evergreenContent: PropTypes.string
};

Layout.defaultProps = {
  isFirstTime: null,
  evergreenContent: null
};

